export default __webpack_public_path__ + "static/media/emoji-smile.1cc5972c.svg";